<template>
    <UiCard class="promotions-mechanism" title="Działanie mechanizmów promocyjnych w zależności od rodzaju Urządzenia na stanowisku sprzedaży" >
        <a :href="`/regulations/${promotionsMechanismFile.path}`"  target="_blank">
            {{promotionsMechanismFile.name}}
        </a>
    </UiCard>
</template>

<script>
import { UiCard } from '../../global/ui'
export default {
    name: 'ContactInfo',
    components: { UiCard },
    data() {
        return{
            promotionsMechanismFile: {
                path: 'Mechanizmy_Mplatform_obslugiwane_na_kasie_lub_stanowisku_POS_v002-opublikowane_20210514.pdf',
                name: 'Mechanizmy_Mplatform_obslugiwane_na_kasie_lub_stanowisku_POS_v002-opublikowane_20210514.pdf'
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.promotions-mechanism{
    height: 100%;;
}
</style>